import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'australian-states';

const AustralianStatesGenerator = createRestAPIModelGenerator(TYPE);
export default AustralianStatesGenerator.createValueListModel();
